import { jwtDecode } from 'jwt-decode';

export function isAdminUser() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return false;
    return jwtDecode(token).esAdmin === true;
  } catch {
    return false;
  }
}
